import toastr from 'toastr/toastr'

toastr.options.progressBar = true;
toastr.options.positionClass = 'toast-bottom-left';

window.toastr = toastr;
